import { render, staticRenderFns } from "./scheme-manage.vue?vue&type=template&id=58f9150c&scoped=true"
import script from "./scheme-manage.vue?vue&type=script&lang=ts"
export * from "./scheme-manage.vue?vue&type=script&lang=ts"
import style0 from "./scheme-manage.vue?vue&type=style&index=0&id=58f9150c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f9150c",
  null
  
)

export default component.exports